import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';

interface ConfirmationDialogProps {
  title: string;
  message: React.ReactNode;
  positiveText?: string;
  positiveAction: () => void;
  negativeText?: string;
  negativeAction: () => void;
  open: boolean;
  sx?: SxProps<Theme>;
}

export default function ConfirmationDialog(props: ConfirmationDialogProps) {
  const { t } = useTranslation('common');

  const {
    title,
    message,
    positiveText,
    positiveAction,
    negativeText,
    negativeAction,
    open,
    ...other
  } = props;

  const yes = positiveText ? positiveText : t('common.yes');
  const no = negativeText ? negativeText : t('common.no');

  return (
    <Dialog disableEscapeKeyDown maxWidth="xs" open={open} {...other}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={negativeAction}>
          {no}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={positiveAction}
          autoFocus>
          {yes}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
